import { render, staticRenderFns } from "./ticketCollectionInformation.vue?vue&type=template&id=373a1b98&scoped=true&"
import script from "./ticketCollectionInformation.vue?vue&type=script&lang=js&"
export * from "./ticketCollectionInformation.vue?vue&type=script&lang=js&"
import style0 from "./ticketCollectionInformation.vue?vue&type=style&index=0&id=373a1b98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a1b98",
  null
  
)

export default component.exports